import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Company {
  _id: string;
  companyName: string;
  email: string;
  name: string;
  role: string;
  [key: string]: any;
}

interface Employee {
  _id: string;
  name: string;
  email: string;
  position: string;
  branchID?: {
    _id: string;
    name: string;
  };
  [key: string]: any;
}

interface CompanyState {
  company: Company | {};
  allCompanies: Company[];
  employees: Employee[];
}

const initialState: CompanyState = {
  company: {},
  allCompanies: [],
  employees: [],
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setAllCompanies: (state, action: PayloadAction<Company[]>) => {
      state.allCompanies = action.payload;
    },
    setCompanyData: (state, action: PayloadAction<Company>) => {
      state.company = action.payload;
    },
    setEmployees: (state, action: PayloadAction<Employee[]>) => {
      state.employees = action.payload;
    },
  },
});

export const { setAllCompanies, setCompanyData, setEmployees } = companySlice.actions;

export default companySlice.reducer;
